<script setup lang="ts">
import { computed } from 'vue'
import type { TextBlock } from '../types'
import { cn } from '@/lib/utils'
import { processDateTimeExpressions } from '../utils/dateTime'
import {
  spacingClasses,
  textAlignClasses,
  textSizeClasses,
  textWeightClasses,
  textColorClasses,
} from '../utils/classes'

const props = defineProps<{ element: TextBlock }>()

const processedText = computed(() => processDateTimeExpressions(props.element.text))
</script>

<template>
  <p
    :class="cn(
      textSizeClasses[props.element.size ?? 'default'],
      textWeightClasses[props.element.weight ?? 'default'],
      textColorClasses[props.element.color ?? 'default'],
      spacingClasses[props.element.spacing ?? 'default'],
      textAlignClasses[props.element.horizontalAlignment ?? 'left'],
      props.element.isSubtle && 'text-muted-foreground',
      !props.element.wrap && 'truncate'
    )"
  >
    {{ processedText }}
  </p>
</template>
